var map = {
	"./barn_owl_hoot.mp3": 3268,
	"./eagle_owl_hoot.mp3": 3269,
	"./elf_owl_hoot.mp3": 3270,
	"./horned_owl_hoot.mp3": 3271,
	"./screech_owl_hoot.mp3": 3272,
	"./snowy_owl_hoot.mp3": 3273
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 385;



//////////////////
// WEBPACK FOOTER
// ./assets/sounds/owl-hoots .\.mp3*
// module id = 385
// module chunks = 0